import type { MessageItem } from 'tripPlanner/components/Chat/MessagesList'

/**
 * When staff inspect an earlier assistant turn, only show messages up to and
 * including that turn. Later messages stay in the live chat but are hidden
 * until inspection exits.
 */
export function filterMessagesUpToStaffRewindPoint(
  messages: Array<MessageItem>,
  inspectedMessageId: string | undefined,
): Array<MessageItem> {
  if (!inspectedMessageId) {
    return messages
  }

  const inspectIndex = messages.findIndex(message => message.id === inspectedMessageId)
  if (inspectIndex === -1) {
    return messages
  }

  return messages.slice(0, inspectIndex + 1)
}
